module.exports = __webpack_public_path__ + "img/13.1fbd6c67.png";